import { useEffect, useState } from "react";

// Replaces the browser's native (tan/yellow) title popups with a WHIP-styled
// tooltip. Any element with a `title` attribute gets it automatically.
export const GlobalTooltip = () => {
  const [tip, setTip] = useState(null);

  useEffect(() => {
    let active = null;
    const restore = () => {
      if (active && active.dataset.whipTip !== undefined) {
        active.setAttribute("title", active.dataset.whipTip);
        delete active.dataset.whipTip;
      }
      active = null;
      setTip(null);
    };
    const place = (el, x, y) => {
      const text = el.getAttribute("title");
      if (!text || !text.trim()) return;
      el.dataset.whipTip = text;
      el.removeAttribute("title");
      active = el;
      setTip({ text, x, y });
    };
    const onOver = (e) => {
      const el = e.target?.closest?.("[title]");
      if (!el || el === active) return;
      restore();
      place(el, e.clientX, e.clientY);
    };
    const onMove = (e) => {
      if (active) setTip((t) => (t ? { ...t, x: e.clientX, y: e.clientY } : t));
    };
    const onOut = (e) => {
      if (active && !active.contains(e.relatedTarget)) restore();
    };
    document.addEventListener("pointerover", onOver, true);
    document.addEventListener("pointermove", onMove, true);
    document.addEventListener("pointerout", onOut, true);
    document.addEventListener("pointerdown", restore, true);
    window.addEventListener("scroll", restore, true);
    return () => {
      document.removeEventListener("pointerover", onOver, true);
      document.removeEventListener("pointermove", onMove, true);
      document.removeEventListener("pointerout", onOut, true);
      document.removeEventListener("pointerdown", restore, true);
      window.removeEventListener("scroll", restore, true);
      restore();
    };
  }, []);

  if (!tip) return null;
  const vw = window.innerWidth;
  const width = Math.min(320, vw - 24);
  const left = Math.max(12, Math.min(tip.x + 14, vw - width - 12));
  const above = tip.y > window.innerHeight - 120;
  return (
    <div
      role="tooltip"
      data-testid="whip-tooltip"
      className="whip-tooltip"
      style={{ position: "fixed", left, top: above ? undefined : tip.y + 18, bottom: above ? window.innerHeight - tip.y + 12 : undefined, maxWidth: width }}
    >
      {tip.text}
    </div>
  );
};
